<template>
  <transition name="fade-spinner">
    <div class="spinner-backdrop" v-if="isSpinnerVisible">
      <div class="spinner-border text-light" role="status">
        <span class="visually-hidden">Завантаження...</span>
      </div>
    </div>
  </transition>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "AppLayoutSpinner",
  setup() {
    const store = useStore();
    const isSpinnerVisible = computed(() => store.getters.isShowSpinner);

    return {
      isSpinnerVisible,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";

.spinner-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.fade-spinner-enter-active,
.fade-spinner-leave-active {
  transition: opacity 0.35s ease;
}
.fade-spinner-enter-from,
.fade-spinner-leave-to {
  opacity: 0;
}
.fade-spinner-enter-to,
.fade-spinner-leave-from {
  opacity: 1;
}
</style>
